module.exports = __webpack_public_path__ + "media/images/privacy_mark-43542e3b1697489d363c82bc7443fac1.png";